export const KEYS_CART = {
  general: {
    title: "cart.general.title",
    note: "cart.general.note",
    remove: "cart.general.remove",
    subtotal: "cart.general.subtotal",
    savings: "cart.general.savings",
    taxes_and_shipping_at_checkout:
      "cart.general.taxes_and_shipping_at_checkout",
    taxes_and_shipping_policy_at_checkout_html:
      "cart.general.taxes_and_shipping_policy_at_checkout_html",
    taxes_included_but_shipping_at_checkout:
      "cart.general.taxes_included_but_shipping_at_checkout",
    taxes_included_and_shipping_policy_html:
      "cart.general.taxes_included_and_shipping_policy_html",
    update: "cart.general.update",
    checkout: "cart.general.checkout",
    subscription_error: "cart.general.subscription_error",
    location_error: "cart.general.location_error",
    empty: "cart.general.empty",
    cookies_required: "cart.general.cookies_required",
    edit: "cart.general.edit",
    cancel: "cart.general.cancel",
    continue_shopping: "cart.general.continue_shopping",
    approx_weight: "cart.general.approx_weight",
    pieces: "cart.general.pieces",
    min_delivery_html: "cart.general.min_delivery_html",
    added_to_cart: "cart.general.added_to_cart",
    view_basket: "cart.general.view_basket",
  },
  item: {
    quantity: "cart.item.quantity",
    max_quantity: "cart.item.max_quantity",
    save: "cart.item.save",
  },
  ship: {
    title: "cart.ship.title",
    price: "cart.ship.price",
    free_delivery: "cart.ship.free_delivery",
    price_unregistered: "cart.ship.price_unregistered",
  },
  label: {
    product: "cart.label.product",
    price: "cart.label.price",
    quantity: "cart.label.quantity",
    total: "cart.label.total",
  },
  recommendations: {
    title: "cart.recommendations.title",
    copy: "cart.recommendations.copy",
    continue: "cart.recommendations.continue",
  },
  subscription: {
    subtitle: "cart.subscription.subtitle",
    description: "cart.subscription.description",
  },
  validation: {
    unavailable: {
      one: "cart.validation.unavailable.one",
      other: "cart.validation.unavailable.other",
    },
    removed: {
      one: "cart.validation.removed.one",
      other: "cart.validation.removed.other",
    },
    updated: "cart.validation.updated",
    item_removed: {
      one: "cart.validation.item_removed.one",
      other: "cart.validation.item_removed.other",
    },
  },
};

export const KEYS_FAVORITE = {
  save: "favorite.save",
  saved: "favorite.saved",
  saving: "favorite.saving",
  remove: "favorite.remove",
  removing: "favorite.removing",
  error: "favorite.error",
  save_for_later: "favorite.save_for_later",
  "no-favorites": "favorite.no-favorites",
};
